export const version = '2.47.6'
